<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div style="position:absolute; top:-60px; right:10px; z-index:9;">
          <vs-button :href="event_url" target="_blank" color="primary" type="flat">Go to Event <i
              class="ml-2 fas fa-external-link-alt"></i></vs-button>
        </div>
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner ">
          <vs-tab label="Event Info">
            <InfoForm :event="event" :role="role" :basicForm="basicForm" :products="productsInSeller" :eventList="eventList" :folder="folder" :checkRefForm=checkRefForm>
            </InfoForm>
          </vs-tab>
          <vs-tab label="Ticket">
            <TicketList :event="event" :role="role" :folder="folder" :products="products" :remainQty="remainQty"
              @loadEvent="loadEvent"></TicketList>
          </vs-tab>
          <vs-tab label="Attendee Info">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Show Attendee Info</span>
                <div style="font-size:0.75rem; color:#aaa;">
                  Additional information of the registrants to be asked
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio vs-name="radios-fields_status" v-model="basicForm.fields_status" vs-value="1">Yes</vs-radio>
                  </li>
                  <li>
                    <vs-radio vs-name="radios-fields_status" v-model="basicForm.fields_status" vs-value="0">No</vs-radio>
                  </li>
                </ul>
              </div>
            </div>

            <vs-divider class="my-3"></vs-divider>

            <CustomFields :e="basicForm.e" :event="event" :field_status="basicForm.fields_status" :basicForm="basicForm" :onSubmit="loadEvent">
            </CustomFields>
          </vs-tab>
          <vs-tab v-if="role=='so-admin' || role=='so-staff' || role=='so-owner'" label="Attendee Role">
            <RoleForm :event="event" @loadEvent="loadEvent">
            </RoleForm>
          </vs-tab>
          <vs-tab label="Boost Sales">
            <BootsaleForm :event="event" :role="role" :basicForm="basicForm"
              :bootsalesForm="bootsalesForm" :folder="folder" :soldbarData="soldbarData"></BootsaleForm>
          </vs-tab>
          <vs-tab label="Tracking">
            <TrackingForm :event="event" :role="role" :basicForm="basicForm" :currencyForm="currencyForm"
              :folder="folder"></TrackingForm>
          </vs-tab>
          <vs-tab label="Event Day" v-if="role=='so-admin' || role=='so-staff' || role=='so-owner'">
            <CheckInForm :event="event" @loadEvent="loadEvent">
            </CheckInForm>
          </vs-tab>
          <vs-tab label="Live" v-if="role=='so-admin' || role=='so-staff' || role=='so-owner'">
            <LiveForm :event="event" :role="role" :liveForm="liveForm" :basicForm="basicForm" :folder="folder"></LiveForm>
          </vs-tab>
          <vs-tab label="Theme">
            <ThemeForm :event="event" :role="role" :assetForm="assetForm" :folder="folder" :basicForm="basicForm">
            </ThemeForm>
          </vs-tab>
          <vs-tab label="Contact">
            <ContactForm :event="event" :role="role" :contactForm="contactForm" :folder="folder" :basicForm="basicForm">
            </ContactForm>
          </vs-tab>
          <vs-tab label="Advanced" v-if="role=='so-admin' || role=='so-staff' || role=='so-owner'">
            <AdvancedForm :event="event" :role="role" :advanceForm="advanceForm" :basicForm="basicForm" :folder="folder" :eventLogInfo="eventLogInfo">
            </AdvancedForm>
          </vs-tab>
          <vs-tab label="User & Role" v-if="role=='so-admin' || role=='so-staff' || role=='so-owner'">
            <div class="text-right">
              <vs-button class="mr-3 mb-2" @click.prevent="assignUserDialog = true">Assign User</vs-button>
            </div>
            <b-table ref="table" style="min-height: 600px" striped hover fixed responsive show-empty sort-icon-left
              :selectable="false" :items="userList.rows" :select-mode="`multi`" :fields="userColumns">
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2" style="height: 600px">
                  <b-spinner class="align-middle"></b-spinner>
                  <div class="mt-3">
                    <strong>Loading...</strong>
                  </div>
                </div>
              </template>
              <template v-slot:cell(role)="data">
                <select class="form-control" v-model="data.item.role" >
                  <option v-for="(role, index) in roleOptions" :value="role" :key="index">
                    {{ role }}
                  </option>
                  <option :value="-1">Remove</option>
                </select>
              </template>
              <template v-slot:cell(action)="data">
                <vs-button style="display:inline-block;" class="mr-2" @click="onUserChanged(data.item)" >Save</vs-button>
              </template>
            </b-table>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>

    <vs-popup title="Assign Customer to this event" :active.sync="assignUserDialog">
      <div style="min-height: 100px" class="m-5">
        <div>
          <vs-input style="width: 100%" label-placeholder="Search an email" v-model="searchEmail"
            v-on:input="debounceInput" />
        </div>
        <div class="my-5">
          <vs-list>
            <vs-list-item v-for="(item, index) in resultUsers" :key="index" :title="item.name" :subtitle="item.email">
              <vs-radio v-if="!item.found" v-model="formUser.email" vs-name="radios1" :vs-value="item.email"></vs-radio>
              <span v-else>{{ item.role }}</span>
            </vs-list-item>
          </vs-list>
        </div>
        <template v-if="formUser.email != null">
          <div class="mt-5">
            <select class="form-control" v-model="formUser.role">
              <option v-for="(role, index) in roleOptions" :value="role" :key="index">
                {{ role }}
              </option>
            </select>
          </div>
          <hr />
          <div class="mt-5 text-center">
            <vs-button color="primary" @click="assignUser()">Assign this User</vs-button>
          </div>
        </template>
      </div>
    </vs-popup>

    <vs-popup
            classContent="popup-confirm"
            title="Confirm Role Change?"
            :active.sync="changeRolePopup"
          >
            <div>Are you sure you want to change the role?</div>
            <div class="wrap-button">
              <vs-button
                color="dark"
                type="border"
                style="font-size: 12px !important;"
                @click="popupActivo=false"
              >
                No
              </vs-button>
              <vs-button
                color="primary"
                style="font-size: 12px !important;"
                @click="onUserChangedAction()"
              >
                Yes
              </vs-button>
            </div>
          </vs-popup>
  </div>
</template>
<script>
import draggable from "vuedraggable";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import moment from "moment-timezone";
import { mapState } from "vuex";

import Service from "@/services";
import { timezones } from "@/utils/Timezones";

import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import CustomFields from "@/components/soldoutt/Customfields";
import InfoForm from "@/components/soldoutt/event/InfoForm";
import BootsaleForm from "@/components/soldoutt/event/BootsaleForm";
import ThemeForm from "@/components/soldoutt/event/ThemeForm";
import TrackingForm from "@/components/soldoutt/event/TrackingForm";
import ContactForm from "@/components/soldoutt/event/ContactForm";
import LiveForm from "@/components/soldoutt/event/LiveForm";
import AdvancedForm from "@/components/soldoutt/event/AdvancedForm";
import TicketList from "@/components/soldoutt/event/TicketList";
import CheckInForm from "@/components/soldoutt/event/CheckInForm";
import RoleForm from "@/components/soldoutt/event/RoleForm";

import { currencyList } from "@/utils/Constants";
import { eventFieldsPermission } from "@/utils/FieldsPermission";

import {
  basicForm,
  assetForm,
  currencyForm,
  liveForm,
  contactForm,
  advanceForm,
  bootsalesForm
} from "@/utils/eventForm";

export default {
  components: {
    VxAutoSuggest,
    CustomFields,
    flatPickr,
    draggable,
    InfoForm,
    BootsaleForm,
    ThemeForm,
    TrackingForm,
    ContactForm,
    LiveForm,
    AdvancedForm,
    TicketList,
    CheckInForm,
    RoleForm,
  },
  props: ["folder"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      }
    })
  },
  data() {
    return {
      changeRolePopup: false,
      userChangeItem: null,
      assignUserDialog: false,
      role: "user",
      event: null,
      activeTab: 0,
      eventFieldsPermission: eventFieldsPermission,
      currencyList: [],
      event_url: null,
      basicForm: basicForm,
      assetForm: assetForm,
      liveForm: liveForm,
      currencyForm: currencyForm,
      contactForm: contactForm,
      advanceForm: advanceForm,
      bootsalesForm: bootsalesForm,
      roleOptions: [
        "admin",
        "staff",
        "marketing",
        "accountant",
        "check-in-staff",
        "so-owner",
        "so-admin",
        "so-staff",
        "so-check-in-staf",
        "so-accountant",
        "guest",
        "organizer"
      ],
      products: [],
      productsInSeller: [],
      userList: [],
      eventList: [],
      userColumns: [
        { label: "Name", key: "name", sortable: false },
        { label: "Email", key: "email", sortable: false },
        { label: "Role", key: "role", sortable: false },
        { label: "Action", key: "action", sortable: false }
      ],
      searchEmail: "",
      resultUsers: [],
      formUser: {
        e: this.folder,
        email: null,
        role: "admin"
      },
      remainQty: null,
      checkRefForm: 0,
      soldbarData: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      timezones: timezones,
      eventLogInfo: {}
    };
  },
  created() {
    this.loadEvent();
    this.currencyList = Object.keys(currencyList);
  },
  methods: {
    moment,
    debounceInput: _.debounce(function () {
      Service.User.search({ email: this.searchEmail }).then(res => {
        this.resultUsers = res.data.users.map(item => {
          //return { ...item };
          let f = this.userList.rows.find(x => x.id == item.id);
          let found = false;
          let role = null;
          if (f) {
            found = true;
            role = f.role;
          }
          return { ...item, found: found, role: role };
        });
      });
    }, 500),
    onUserChangedAction() {
      if (!this.userChangeItem) {
        this.changeRolePopup =false
      }
      let data = {
        e: this.folder,
        email: this.userChangeItem.email,
        role: this.userChangeItem.role
      };
      Service.Event.assignUser(data).then(res => {
        if (res.success) {
          this.$vs.notify({
            color: "success",
            title: "Complete",
            text: "Update role complete!"
          });
        }
      });
      this.userChangeItem = null;
      this.changeRolePopup =false
    },
    onUserChanged(item) {
      this.userChangeItem = item;
      this.changeRolePopup = true;
    },
    loadEvent() {
      Service.Event.get(this.folder)
        .then(res => {
          this.event = res.data.event;
          this.role = res.data.role;

          this.event_url =
            "https://" +
            this.event.merchant.domain +
            "/" +
            this.event.slug +
            "/register";

          this.basicForm.featured_status = this.event.featured_status === null ? 0 : this.event.featured_status;

          this.basicForm.related_product_ids = this.event.related_product_ids;
          this.basicForm.related_event_ids = this.event.related_event_ids;
          this.basicForm.keywords = this.event.keywords?this.event.keywords.split(","):[];

          this.getTicketList(this.folder, this.event)
          this.getAdvanceTab(this.event)
          this.getContactTab(this.event)
          this.getThemeTab(this.event)
          this.getTrackingTab(this.event)
          this.getCurrency(this.event)
          this.getPrivacy(this.event)
          this.getBootsSaleTab(this.event)
          let data = {
            e: this.folder
          };

          let params = Object.keys(data)
            .map(key => key + "=" + data[key])
            .join("&");

          Service.Product.getsInSeller(params).then(res => {
            this.productsInSeller = res.data.rows;
            this.productsInSeller.sort(this.compareValues("weight", "desc"));
          });

          this.basicForm.e = this.folder;
          this.basicForm.pro_name = this.event.pro_name;
          this.basicForm.pro_shortname = this.event.pro_shortname;
          this.basicForm.slug = this.event.slug;
          this.basicForm.venue = this.event.venue;
          this.basicForm.timezone = this.event.timezone;
          this.basicForm.shortdesc = this.event.pro_shortdesc;
          this.basicForm.landingpage = this.event.landingpage;

          this.basicForm.selldaterange = [
            moment.utc(this.event.selldate_start, 'YYYY-MM-DD HH:mm:ss')
              // .add(7, "hours")
              // .tz(this.event.timezone) //timezone of event // DB convert time with timezone already
              .format("YYYY-MM-DD HH:mm"),
            moment.utc(this.event.selldate_end, 'YYYY-MM-DD HH:mm:ss')
              // .add(7, "hours")
              // .tz(this.event.timezone) //timezone of event // DB convert time with timezone already
              .format("YYYY-MM-DD HH:mm")
          ];

          if (this.event.pro_longdesc == null) {
            this.basicForm.longdesc = "";
          } else {
            this.basicForm.longdesc = this.event.pro_longdesc;
          }

          this.basicForm.pro_type = this.event.pro_type;
          // this.assetForm.font = this.event.font;
          this.basicForm.sell_status = this.event.sell_status;

          this.basicForm.instruction = this.event.instruction || '';
          this.basicForm.lobby_intro = this.event.lobby_intro || '';
          this.basicForm.intro = this.event.intro || '';
          this.basicForm.terms = this.event.terms || '';

          this.checkRefForm = this.event.altcurrencyrate ? 1 : 0
          this.basicForm.hasReference = this.event.altcurrencycode ? 1 : 0;


          /* boolean START */
          let waitlist = 0;
          if (this.event.waitlist) {
            waitlist = 1;
          }
          this.basicForm.waitlist = waitlist;
          /* boolean END */

          // let featured_status = 0;
          // if (this.event.featured_status) {
          //   featured_status = 1;
          // }

          this.basicForm.taxinv_instruction = this.event.taxinv_instruction;

          this.basicForm.taxinv_prefix = this.event.taxinv_prefix;
          this.basicForm.taxinv_supportno = this.event.taxinv_supportno;
          this.basicForm.taxinv_sign = this.event.taxinv_sign;

          let fields_status = 0;
          if (this.event.fields_status) {
            fields_status = 1;
          }
          this.basicForm.fields_status = fields_status;

          /* <<<<<<>>>>>>>> */
          let publish_status = 0;
          if (this.event.publish_status) {
            publish_status = 1;
          }
          this.basicForm.publish_status = publish_status;
          /* <<<<<<>>>>>>>> */

          this.basicForm.daterange = [
            moment(this.event.datetime).format("YYYY-MM-DD HH:mm"),
            moment(this.event.datetime_end).format("YYYY-MM-DD HH:mm")
          ];

          this.time = this.event.datetime

          this.basicForm.mode = this.event.mode;
          // this.basicForm.freeevent = this.event.freeevent === null ? 0: this.event.freeevent;
          this.basicForm.privacy = this.event.privacy;
          this.basicForm.private_token = this.event.private_token;
          this.basicForm.sync = true;

          this.basicForm.wht_vat = this.event.wht_vat;
          this.basicForm.wht_later = this.event.wht_later === null ? 0 : this.event.wht_later;

          this.basicForm.wht_status = this.event.wht_status === null ? 0 : this.event.wht_status;
          // if (this.event.wht_status == null) {
          //   this.basicForm.wht_status = 0;
          // }

          // if (this.event.wht_later == null) {
          //   this.basicForm.wht_later = 0;
          // }

          this.basicForm.taxinv_status = this.event.taxinv_status === null ? 0 : this.event.taxinv_status;
          // if (this.event.taxinv_status == null) {
          //   this.basicForm.taxinv_status = 0;
          // }

          this.basicForm.terms_require = this.event.terms_require === null ? 0 : this.event.terms_require;
          // if (this.event.terms_require == null) {
          //   this.basicForm.terms_require = 0;
          // }

          this.basicForm.taxinv_onrequest = this.event.taxinv_onrequest === null ? 0 : this.event.taxinv_onrequest;

          // if (this.event.taxinv_onrequest == null) {
          //   this.basicForm.taxinv_onrequest = 0;
          // }

          this.basicForm.digitalinvoice = this.event.digitalinvoice === null ? 0 : this.event.digitalinvoice;
          // if (this.event.digitalinvoice == null) {
          //   this.basicForm.digitalinvoice = 0;
          // }

          this.basicForm.norefund = this.event.norefund ? 1 : 0;
          this.basicForm.refundpolicy = this.event.refundpolicy;

          // this.basicForm.pay_deadline = this.event.pay_deadline;

          // this.assetForm.txtcolor = this.event.txtcolor;
          // this.assetForm.bgcolor = this.event.bgcolor;

          // this.basicForm.currency = this.event.currency;
          // this.basicForm.altcurrencycode = this.event.altcurrencycode;
          // this.basicForm.altcurrencyrate = this.event.altcurrencyrate? parseFloat(this.event.altcurrencyrate).toFixed(4): null;

          // if (this.basicForm.altcurrencycode != null) {
          //   this.currencyForm.hasReference = true;
          // }

          // this.basicForm.invitetext = this.event.invitetext;

          // this.basicForm.gaid = this.event.gaid;
          // this.basicForm.fbpid = this.event.fbpid;
          // this.basicForm.awcid = this.event.awcid;
          // this.basicForm.awclabel = this.event.awclabel;
          // this.basicForm.code_footer = this.event.code_footer;
          this.basicForm.max_attendee = this.event.max_attendee;
          this.basicForm.norefund = this.event.norefund ? 1 : 0
          this.basicForm.refundpolicy = this.event.refundpolicy
          this.basicForm.tickettransfer = this.event.tickettransfer ? 1 : 0;
          // this.advanceForm.max_attendee = this.event.max_attendee;
          this.basicForm.max_attendee = this.event.max_attendee;

          this.liveForm.live_engine = this.event.live_engine;
          this.liveForm.live_engine_2 = this.event.live_engine_2;
          this.liveForm.rerun_status = this.event.rerun_status;
          if (this.event.rerun_status == null) {
            this.liveForm.rerun_status = 0;
          }

          this.liveForm.zoom_status = this.event.zoom_status;
          if (this.event.zoom_status == null) {
            this.liveForm.rerun_zoom_statusstatus = 0;
            this.liveForm.zoom_status = 0;
          }

          this.liveForm.zoom_account_no = this.event.zoom_account_no;
          this.liveForm.zoom_webinar_id = this.event.zoom_webinar_id;
          this.liveForm.vimeo_playback_url = this.event.vimeo_playback_url;
          this.liveForm.dacast_playback_url = this.event.dacast_playback_url;
          this.liveForm.ivs_viewer_endpoint_url = this.event.ivs_viewer_endpoint_url;
          this.liveForm.ivs_creator_endpoint_url = this.event.ivs_creator_endpoint_url;
          this.liveForm.ivs_creator_stream_key = this.event.ivs_creator_stream_key;
          this.liveForm.ivs_channel_id = this.event.ivs_channel_id;
          this.liveForm.ivs_playback_url = this.event.ivs_playback_url;
          this.liveForm.zoom_session_type = this.event.zoom_session_type;
          this.liveForm.join_url = this.event.join_url;
          this.liveForm.speaker_url = this.event.speaker_url;

          this.basicForm.taxinv_sign = this.event.taxinv_sign;

          // this.contactForm.supportno = this.event.supportno;
          // this.contactForm.lineid = this.event.lineid;
          // this.contactForm.lineaddurl = this.event.lineaddurl;
          // this.contactForm.fbpage = this.event.fbpage;

          // this.advanceForm.freecode = this.event.freecode;
          // this.advanceForm.weight = this.event.weight;
          // this.advanceForm.pay_deadline = this.event.pay_deadline;

          // this.advanceForm.pay_creditcard = this.event.pay_creditcard ? 1: 0;

          // this.advanceForm.pay_transfer = this.event.pay_transfer ? 1: 0;

          // this.advanceForm.zapier_status = this.event.zapier_status? 1: 0;

          // this.advanceForm.zapier_webhook = this.event.zapier_webhook;

          // this.advanceForm.engnameonly = this.event.engnameonly? 1:0;

          // this.advanceForm.remark = this.event.remark;
          // this.advanceForm.fee = this.event.fee;
          // this.advanceForm.int_invoiceno = this.event.int_invoiceno;
          // this.advanceForm.int_invoicedate = this.event.int_invoicedate;
          // this.advanceForm.int_remark = this.event.int_remark;
          // this.advanceForm.enable_child_sessions = this.event.enable_child_sessions? this.event.enable_child_sessions: '0';
          // this.advanceForm.trash_status = this.event.trash_status;
          // this.advanceForm.pay_deadline = this.event.pay_deadline ? this.event.pay_deadline: 1440;

          // Advance Tab
          // this.basicForm.freecode = this.event.freecode;
          // this.basicForm.weight = this.event.weight;
          // this.basicForm.pay_deadline = this.event.pay_deadline;

          // this.basicForm.pay_creditcard = this.event.pay_creditcard === null ? 1: this.event.pay_creditcard;

          // this.basicForm.pay_transfer = this.event.pay_transfer === null ? 1: this.event.pay_transfer;

          // this.basicForm.zapier_status = this.event.zapier_status? 1: 0;

          // this.basicForm.zapier_webhook = this.event.zapier_webhook;

          // this.basicForm.engnameonly = this.event.engnameonly? 1:0;

          // this.basicForm.remark = this.event.remark;
          // this.basicForm.fee = this.event.fee;
          // this.basicForm.int_invoiceno = this.event.int_invoiceno;
          // this.basicForm.int_invoicedate = this.event.int_invoicedate;
          // this.basicForm.int_remark = this.event.int_remark;
          // this.basicForm.enable_child_sessions = this.event.enable_child_sessions? this.event.enable_child_sessions: '0';
          // this.basicForm.trash_status = this.event.trash_status;
          // this.basicForm.pay_deadline = this.event.pay_deadline ? this.event.pay_deadline: 1440;


          // this.bootsalesForm.countdown = this.event.countdown? this.event.countdown: 0
          // if (this.bootsalesForm.countdown === "") {
          //   this.bootsalesForm.countdown = 0
          // }
          // this.bootsalesForm.promotext = this.event.promotext;
          // this.bootsalesForm.countdowntext = this.event.countdowntext;
          // this.bootsalesForm.soldbar = this.event.soldbar? this.event.soldbar: 0;
          // this.bootsalesForm.bootSaleRange = [
          //   moment(this.event.soldbar_start).format("YYYY-MM-DD HH:mm"),
          //   moment(this.event.soldbar_end).format("YYYY-MM-DD HH:mm")
          // ]
          // this.bootsalesForm.soldbar_start = this.event.soldbar_start;
          // this.bootsalesForm.soldbar_end = this.event.soldbar_end;
          // this.bootsalesForm.socialproof = this.event.socialproof? this.event.socialproof: 0;
          // this.bootsalesForm.exitpopup = this.event.exitpopup? this.event.exitpopup: 0;
          // this.bootsalesForm.exitpopuptext = this.event.exitpopuptext;
          // this.bootsalesForm.friendgetfriend = this.event.invitetext? 1: 0;
          // this.bootsalesForm.invitetext = this.event.invitetext;

          // this.remainQty = this.event.max_attendee;

          // Service.Event.getProducts(this.folder).then(products => {
          //   this.products = products.data.items.map(item => {
          //     let sell_status = "soldout";
          //     if (item.sell_status == 1 && item.soldout == 1) {
          //       sell_status = "soldout";
          //     }
          //     if (item.sell_status == 0 && item.soldout == 0) {
          //       sell_status = "closed";
          //     }
          //     if (item.sell_status == null && item.soldout == null) {
          //       sell_status = "closed";
          //     }
          //     if (item.sell_status == 1 && item.soldout == 0) {
          //       sell_status = "open";
          //     }
          //     if (item.sell_status == 1 && item.soldout == null) {
          //       sell_status = "open";
          //     }
          //     return { ...item, sell_status: sell_status };
          //   });

          //   this.remain_quantity = parseInt(products.data.remain_free);
          //   this.products.sort(this.compareValues("weight", "desc"));
          // });

          this.getUserRole(this.event)

          let dataMyEvent = {
            e: this.folder,
            s: this.event.merchant.s,
            perPage: 999
          };

          let paramsMyEvent = Object.keys(dataMyEvent)
            .map(key => key + "=" + dataMyEvent[key])
            .join("&");

          Service.Event.myEventsWithoutDetail(paramsMyEvent)
            .then(res2 => {
              this.eventList = res2.data.rows
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(e => {
          console.log(e, 'error')
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });

    },
    getPrivacy(val) {
      this.basicForm.privacy = val.privacy
    },
    getTicketList(folder, event) {
      this.remainQty = event.max_attendee;
      Service.Event.getProducts(folder).then(products => {
        this.products = products.data.items.map(item => {
          let sell_status = "soldout";
          if (item.sell_status == 1 && item.soldout == 1) {
            sell_status = "soldout";
          }
          if (item.sell_status == 0 && item.soldout == 0) {
            sell_status = "closed";
          }
          if (item.sell_status == null && item.soldout == null) {
            sell_status = "closed";
          }
          if (item.sell_status == 1 && item.soldout == 0) {
            sell_status = "open";
          }
          if (item.sell_status == 1 && item.soldout == null) {
            sell_status = "open";
          }
          return { ...item, sell_status: sell_status };
        });

        this.remain_quantity = parseInt(products.data.remain_free);
        this.products.sort(this.compareValues("weight", "desc"));
      });
    },
    async getAdvanceTab(val) {
      await val
      this.eventLogInfo = val
      this.basicForm.max_attendee = val.max_attendee;
      this.basicForm.engnameonly = val.engnameonly ? 1 : 0;
      this.basicForm.freecode = val.freecode;
      this.basicForm.weight = val.weight;
      this.basicForm.pay_creditcard = val.pay_creditcard != null ? val.pay_creditcard : 1;
      this.basicForm.pay_transfer = val.pay_transfer != null ? val.pay_transfer : 1;
      this.basicForm.pay_deadline = val.pay_deadline ? val.pay_deadline : 1440;
      this.basicForm.zapier_status = val.zapier_status ? 1 : 0;
      this.basicForm.zapier_webhook = val.zapier_webhook;
      this.basicForm.remark = val.remark;
      this.basicForm.fee = val.fee;
      this.basicForm.int_invoiceno = val.int_invoiceno;
      this.basicForm.int_invoicedate = val.int_invoicedate;
      this.basicForm.int_remark = val.int_remark;
      this.basicForm.enable_child_sessions = val.enable_child_sessions ? val.enable_child_sessions : '0';
    },
    getUserRole(val) {
      let data = { e: this.folder, perPage: 100 };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Merchant.get_users(val.merchant.s, params).then(
        res => {
          if (res.data.total < 1) {
            this.assignUserDialog = true;
          }
          this.userList = res.data;
        }
      );
    },
    getContactTab(val) {
      this.contactForm.supportno = val.supportno;
      this.contactForm.lineid = val.lineid;
      this.contactForm.lineaddurl = val.lineaddurl === 'null' ? '' : val.lineaddurl;
      this.contactForm.fbpage = val.fbpage;
    },

    getThemeTab(val) {
      this.assetForm.txtcolor = val.txtcolor;
      this.assetForm.bgcolor = val.bgcolor;
      this.assetForm.font = val.font;
      this.event.bgimg = val.bgimg;
    },
    getTrackingTab(val) {
      this.basicForm.gaid = val.gaid || '';
      this.basicForm.fbpid = val.fbpid || '';
      this.basicForm.awcid = val.awcid || '';
      this.basicForm.awclabel = val.awclabel || '';
      this.basicForm.code_footer = val.code_footer || '';
    },
    async getBootsSaleTab(val) {
      await val
      this.bootsalesForm = val
      this.bootsalesForm.promotext = val.promotext;
      this.bootsalesForm.countdown = val.countdown ? val.countdown : 0
      if (this.bootsalesForm.countdown === "") {
        this.bootsalesForm.countdown = 0
      }
      this.bootsalesForm.countdowntext = val.countdowntext;
      this.bootsalesForm.soldbar = val.soldbar ? val.soldbar : 0;
      this.bootsalesForm.bootSaleRange = [
        moment(val.soldbar_start).format("YYYY-MM-DD HH:mm"),
        moment(val.soldbar_end).format("YYYY-MM-DD HH:mm")
      ]
      this.bootsalesForm.soldbar_start = val.soldbar_start;
      this.bootsalesForm.soldbar_end = val.soldbar_end;
      this.bootsalesForm.socialproof = val.socialproof ? val.socialproof : 0;
      this.bootsalesForm.exitpopup = val.exitpopup ? val.exitpopup : 0;
      this.bootsalesForm.exitpopuptext = val.exitpopuptext;
      this.bootsalesForm.friendgetfriend = val.invite_status ? 1 : 0;
      this.bootsalesForm.invitetext = val.invitetext;
    },

    getCurrency(val) {
      this.basicForm.freeevent = val.freeevent === null ? 0 : val.freeevent;
      this.basicForm.currency = val.currency
      this.checkRefForm = val.altcurrencyrate ? 1 : 0
      this.basicForm.altcurrencycode = val.altcurrencycode;
      this.basicForm.altcurrencyrate = val.altcurrencyrate ? parseFloat(val.altcurrencyrate).toFixed(4) : ''
      this.currencyForm.hasReference = val.altcurrencycode != null ? true : false

      this.basicForm.taxinv_status = val.taxinv_status === null ? 0 : val.taxinv_status
      this.basicForm.wht_vat = val.wht_vat;
      this.basicForm.wht_later = val.wht_later === null ? 0 : val.wht_later;
      this.basicForm.wht_status = val.wht_status === null ? 0 : val.wht_status;
      this.basicForm.terms_require = val.terms_require === null ? 0 : val.terms_require;
      this.basicForm.taxinv_onrequest = val.taxinv_onrequest === null ? 0 : val.taxinv_onrequest;
      this.basicForm.digitalinvoice = val.digitalinvoice === null ? 0 : val.digitalinvoice;
      this.basicForm.norefund = val.norefund ? 1 : 0;
      this.basicForm.refundpolicy = val.refundpolicy;
      this.basicForm.invitetext = val.invitetext;
      this.basicForm.taxinv_prefix = val.taxinv_prefix
      this.basicForm.taxinv_sign = val.taxinv_sign
      this.basicForm.taxinv_instruction = val.taxinv_instruction
      this.basicForm.taxinv_supportno = val.taxinv_supportno
    },

    assignUser() {
      Service.Event.assignUser(this.formUser).then(res => {
        if (res.success) {
          this.$vs.notify({
            color: "success",
            title: "Complete",
            text: "Assigned user to event!"
          });
          this.assignUserDialog = false;
        }
      });
    },
    compareValues(key, order = "asc") {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    }
  }
};
</script>
